var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3271 8L11.0407 7.29941C11.4226 7.6884 11.4226 8.3116 11.0407 8.70059L10.3271 8ZM5.68631 4.70059C5.29939 4.3065 5.30519 3.67336 5.69929 3.28644C6.09338 2.89951 6.72651 2.90532 7.11344 3.29941L5.68631 4.70059ZM7.11344 12.7006C6.72651 13.0947 6.09338 13.1005 5.69929 12.7136C5.30519 12.3266 5.29939 11.6935 5.68631 11.2994L7.11344 12.7006ZM9.61358 8.70059L5.68631 4.70059L7.11344 3.29941L11.0407 7.29941L9.61358 8.70059ZM11.0407 8.70059L7.11344 12.7006L5.68631 11.2994L9.61358 7.29941L11.0407 8.70059Z",
    fill: "#4ED5D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.648db252c7b5068a41e195778a35e87e.svg";
export { ForwardRef as ReactComponent };